import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import { css } from '@emotion/react';
import { useHover } from '@lusha-engage/hooks';
import { useTooltipContext, getTooltipProps } from '@lusha-ui/tooltip';
import React, { useEffect, useMemo } from 'react';
import StarActive1 from '../assets/star-active-1.svg';
import StarActive2 from '../assets/star-active-2.svg';
import StarActive3 from '../assets/star-active-3.svg';
import StarActive4 from '../assets/star-active-4.svg';
import StarActive5 from '../assets/star-active-5.svg';
import StarActive from '../assets/star-active.svg';
import StarIdle1 from '../assets/star-idle-1.svg';
import StarIdle2 from '../assets/star-idle-2.svg';
import StarIdle3 from '../assets/star-idle-3.svg';
import StarIdle4 from '../assets/star-idle-4.svg';
import StarIdle5 from '../assets/star-idle-5.svg';
function Star(props) {
    const { active, isLastActive, value, onHover, onSelect } = props;
    const { onMouseLeave, onMouseEnter, hovered } = useHover();
    const tooltipCtx = useTooltipContext();
    const iconElement = useMemo(() => {
        if (active) {
            if (!isLastActive) {
                return _jsx(StarActive, {});
            }
            switch (value) {
                case 1:
                    return _jsx(StarActive1, {});
                case 2:
                    return _jsx(StarActive2, {});
                case 3:
                    return _jsx(StarActive3, {});
                case 4:
                    return _jsx(StarActive4, {});
                case 5:
                    return _jsx(StarActive5, {});
                default:
                    return _jsx(StarActive, {});
            }
        }
        switch (value) {
            case 1:
                return _jsx(StarIdle1, {});
            case 2:
                return _jsx(StarIdle2, {});
            case 3:
                return _jsx(StarIdle3, {});
            case 4:
                return _jsx(StarIdle4, {});
            case 5:
                return _jsx(StarIdle5, {});
        }
    }, [value, active, isLastActive]);
    function handleClick() {
        onSelect(value);
    }
    useEffect(() => {
        if (hovered) {
            onHover(value);
        }
        else {
            // onHover(null)
        }
    }, [hovered]);
    const tooltipTxt = useMemo(() => {
        switch (value) {
            case 1:
                return 'Very poor';
            case 2:
                return 'Poor';
            case 3:
                return 'Good';
            case 4:
                return 'OK';
            case 5:
                return 'Excellent';
            default:
                return '';
        }
    }, [value]);
    return (_jsx("div", Object.assign({ onClick: handleClick, onMouseEnter: onMouseEnter, onMouseLeave: onMouseLeave, css: css `
        cursor: pointer;
        width: 33px;
      ` }, getTooltipProps({
        tooltipId: tooltipCtx === null || tooltipCtx === void 0 ? void 0 : tooltipCtx.id,
        content: tooltipTxt,
        place: 'bottom',
    }), { children: iconElement })));
}
export default Star;
